import { render, staticRenderFns } from "./appoint-input.vue?vue&type=template&id=38f63c00&scoped=true&"
import script from "./appoint-input.vue?vue&type=script&lang=js&"
export * from "./appoint-input.vue?vue&type=script&lang=js&"
import style0 from "./appoint-input.vue?vue&type=style&index=0&id=38f63c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f63c00",
  null
  
)

export default component.exports